import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { translate } from 'react-i18next'

const styles = theme => ({
    image: {
        width: 100,
        height: 100,
        borderRadius: 4,
    },
    imageDiv: {
        width: 100,
        height: 100,
    },
    detail: {
        paddingLeft: 8
    },
    info: {
        display: 'flex',
    },
    about: {
        height: 100,
        overflow: 'hidden',
    },
    socialInfo: {
        color: '#3b5998',
        marginRight: 8,
    }
})
 
const GridProfile = ({ classes, post, t, i18n }) => { 
  return (
    <ListItem divider={true}>
        <Grid container>
            <Grid item xs={12}>
                <div className={classes.info}>
                    <div className={classes.imageDiv}>
                        <img src={`${post.photoURL}?type=large`} alt={post.name} className={classes.image} />
                    </div>
                    <div className={classes.detail}>
                        <Typography variant="title" color="default" noWrap>
                            {post.displayName}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {/* TODO: If user select certain region, show specific address */}
                            {/* {post.address} */}
                            {`${post.region}, ${post.country}`}
                        </Typography>
                        <span className={classes.socialInfo}>
                            <i className="far fa-thumbs-up"></i>{' ' + post.fblike}
                        </span>
                        <span className={classes.socialInfo}>
                            <i className="far fa-comment"></i>{' ' + post.fbcomment}
                        </span>
                        {
                            post.video && 
                            <span className={classes.socialInfo}>
                                <i className="fab fa-youtube" style={{ color: '#FF5252' }}></i>
                            </span>
                        }
                        {/* <Typography variant="body2">
                            區域:{' '}{post.location ? Object.values(post.locations).map(item => item.title).join(' , ') + ' , ' + Object.values(post.services).map(item => item.title).join(' , ') : ''}
                        </Typography> */}
                        <Typography variant="body2" color="primary">
                            {post.categories ? Object.keys(post.categories).map(item => t(`alias:${item}`)).join(', ') : ''}
                        </Typography>
                    </div>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body2" color="textSecondary" className={classes.about}>
                    {post.about}
                </Typography>
            </Grid>
        </Grid>
    </ListItem>
  )
}

export default translate(['translations', 'alias'])(withStyles(styles)(GridProfile))


// WEBPACK FOOTER //
// ./src/components/GridProfile.js